export const API_SERVER_URL =
	process.env.NODE_ENV === 'development'
		? "http://210.112.118.120:8083/"
		// ? "http://10.50.3.205:8083/"
		// ? "https://manage.incarmortgage.co.kr/"
		: ""
export const rules = {
	nn: [value => !!value || '내용을 입력해주세요'],
	en: [value => /^[a-zA-Z]*$/.test(value) || '영어만 입력해주세요'],
	kr: [value => /^[가-힣]*$/.test(value) || '영어만 입력해주세요'],
	num: [value => !!/^[0-9]*$/.test(value) || '숫자만 입력해주세요'],
	enNum: [value => !!/^[A-Za-z0-9+]*$/.test(value) || '숫자 및 영어만 입력해주세요'],
	hyphenNum: [value => (!!/^[0-9](?:[0-9]|-(?!-))*[0-9]$/.test(value) || !value) || '숫자와 -(하이픈)만 입력해주세요'],
	email: [value => !!/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i.test(value) || '이메일 형식을 입력해주세요'],
	businessNumber: [value => (/^[0-9]{3}-[0-9]{2}-[0-9]{5}/.test(value) || (value.length === 10 && !!/^[0-9]*$/.test(value)) ) || '사업자번호 양식에 맞춰주세요'],
	maxLengthRule: [value => !(value && value.length > 8) || '8자리 최대 입력']
};

const ORG_TYPE_LIST = [
	{ text: "부서", value: "ORG" },
	{ text: "관리자", value: "ADMIN" },
	{ text: "매니저", value: "MANAGER" },
	{ text: "", value: "USER" }
];

const MEMBER_ROLE_LIST = [
	{ text: "관리자", value: "ADMIN" },
	{ text: "매니저", value: "MANAGER" },
	{ text: "사용자", value: "USER" }
];

const POSITION_LIST = [
	{ text: "대표", value: "대표" },
	{ text: "상무", value: "상무" },
	{ text: "부장", value: "부장" },
	{ text: "과장", value: "과장" },
	{ text: "매니저", value: "매니저" },
	{ text: "관리팀장", value: "관리팀장" },
	{ text: "영업팀장", value: "영업팀장" },
	{ text: "팀원", value: "팀원" }
];

const YN_LIST = [
	{ text: "Y", value: "Y" },
	{ text: "N", value: "N" },
];

const SEX_LIST = [
	{ text: "남자", value: "1" },
	{ text: "여자", value: "2" }
];

const LOAN_TYPE_LIST = [
	{
		type: "주택담보", value: "house",
		subTypeList: [
			{ subType: "일반", subValue: "gen" },
			{ subType: "빌라", subValue: "vil" }
		],
	},
	{
		type: "유동화적격", value: "securitization",
		subTypeList: [
			{ subType: "장기고정금리", subValue: "lfixed" },
			{ subType: "금리고정형", subValue: "fixed" }
		],
	},
	{
		type: "부동산담보", value: "realestate",
		subTypeList: [
			{ subType: "주거용오피스텔", subValue: "resiofficetel" }
		],
	},
	{
		type: "전세자금", value: "jeonse",
		subTypeList: [],
	},
	{
		type: "자동차금융", value: "carfinance",
		subTypeList: [
			{ subType: "신차/택시", subValue: "newtaxi" },
			{ subType: "화물차", subValue: "truck" },
			{ subType: "중고차", subValue: "used" }
		],
	},
	// 집단대출 부터 중개업소(유,무) X
	{
		type: "집단대출", value: "grploan",
		subTypeList: [
			{ subType: "입주잔금", subValue: "movebal" },
			{ subType: "전세대출", subValue: "jeonse" },
			{ subType: "이주비", subValue: "movecost" },
			{ subType: "중도금(대면)", subValue: "interimface" },
			{ subType: "중도금(비대면)", subValue: "interimremote" }
		],
	},
	{
		type: "신용대출", value: "crdtloan",
		subTypeList: [
			{ subType: "새희망홀씨", subValue: "newholssi" }
		],
	}
];

const CATEGORY_ROLE_LIST = [
	{ text: "관리자", value: "ADMIN" },
	{ text: "매니저", value: "MANAGER" },
	{ text: "사용자", value: "USER" }
];

const NOTICE_LEVEL_LIST = [
	{ text: "일반", value: 1 },
	{ text: "지역공지", value: 2 },
	{ text: "전체공지", value: 3 }
];

const CERTIFICATE_TYPE_LIST = [
	{ text: "위촉증명서", value: "위촉증명서" },
	{ text: "경력증명서", value: "경력증명서" },
	{ text: "소득자료증명서", value: "소득자료증명서" },
	{ text: "명함신청", value: "명함신청" }
];

const CERTIFICATE_STATE_LIST = [
	{ text: "요청", value: "REQ" },
	{ text: "확인", value: "CONF" },
	{ text: "완료", value: "COMP" },
	{ text: "거절", value: "REJECT" }
];

export default {
	ORG_TYPE_LIST,
	MEMBER_ROLE_LIST,
	POSITION_LIST,
	YN_LIST,
	SEX_LIST,
	LOAN_TYPE_LIST,
	CATEGORY_ROLE_LIST,
	NOTICE_LEVEL_LIST,
	CERTIFICATE_TYPE_LIST,
	CERTIFICATE_STATE_LIST
}